if ($('.chat-history') && $('.chat-history').length > 0) {
    let chatWrapper = $('.chat-history');
    chatWrapper.animate({
        scrollTop: chatWrapper.prop('scrollHeight')
    }, 0);
}

$('body').on('submit', '#sendMessageForm', function (e) {
    e.preventDefault();
    let chatWrapper = $('.chat-history');
    let url = $(this).attr('action');
    let method = $(this).attr('method');
    let formData = new FormData($(this).get(0));
    $(this).trigger('reset');
    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        processData: false,
        contentType: false,
        data: formData,
        success: function (data) {
            chatWrapper.find('ul').append(data.html);
            chatWrapper.animate({
                scrollTop: chatWrapper.prop('scrollHeight')
            }, 1000);
        }
    });
});
